import { List, Map, OrderedMap, OrderedSet } from 'immutable';

import { SORT_DIRECTION, TEST_CASE_PAGE_PER_PAGE, TIME_INTERVAL_OPTIONS } from '../../../constants';
import { parseTest, parseUsers } from './utils';

export const createTestCaseReducers = ({
  types,
  JobRecord,
  userIdKey = 'id',
}) => {
  const initialState = Map({
    loading: false,
    initialized: false,
    tests: List(),
    total: 0,
    users: OrderedMap(),
    pagination: Map({
      current: 1,
      size: TEST_CASE_PAGE_PER_PAGE,
    }),
    sort: Map({
      direction: SORT_DIRECTION.DESCENDING,
      field: 'creation_time',
    }),
    stats: Map({
      statuses: {},
      maxDuration: 0,
    }),
    trends: Map({
      histogram: OrderedSet(),
      loading: false,
      interval: TIME_INTERVAL_OPTIONS.daily.key,
      selectedBar: null,
    }),
  });

  const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case types.INITIALIZED:
      case types.GET_TESTS.REQUEST:
        return state.set('loading', true);
      case types.GET_TESTS.SUCCESS:
        return state.withMutations((newState) => {
          const tests = payload.items.map((test) => (
            new JobRecord(parseTest(test, state.get('users')))
          ));

          newState
            .set('tests', List(tests))
            .set('initialized', true)
            .set('loading', false)
            .set('total', payload.total)
            .setIn(['stats', 'statuses'], payload.statuses)
            .setIn(['stats', 'maxDuration'], payload.max_duration);
        });
      case types.GET_TESTS.FAILURE:
        return state.withMutations((newState) => {
          newState
            .set('loading', false)
            .set('tests', initialState.get('tests'));
        });
      case types.FETCH_USERS.SUCCESS:
        return state.set('users', parseUsers(payload.results));
      case types.FETCH_USER.SUCCESS:
        return state.setIn(['users', payload[userIdKey]], payload);
      case types.UPDATE_TEST_OWNER: {
        return state.withMutations((newState) => {
          const testIndex = newState.get('tests').findIndex((test) => test.get('id') === payload.id);

          if (newState.get('initialized')) {
            newState.setIn(['tests', testIndex, 'owner'], payload.owner);
          }
        });
      }
      case types.CHANGE_PAGE:
        return state.setIn(['pagination', 'current'], payload);
      case types.RESET_PAGE:
        return state.setIn(['pagination', 'current'], initialState.getIn(['pagination', 'current']));
      case types.CHANGE_SORTING:
        return state.withMutations((newState) => {
          newState
            .setIn(['sort', 'direction'], payload.direction)
            .setIn(['sort', 'field'], payload.field);
        });
      case types.GET_TEST_CASES_TRENDS.REQUEST:
        return state.setIn(['trends', 'loading'], true);
      case types.GET_TEST_CASES_TRENDS.SUCCESS:
        return state.withMutations((newState) => {
          const { histogram } = payload;
          newState.set('trends', newState.get('trends').merge({
            histogram: OrderedSet(histogram),
            loading: false,
          }));
        });
      case types.GET_TEST_CASES_TRENDS.FAILURE:
        return state.setIn(['trends', 'loading'], false);
      case types.CHANGE_TRENDS_INTERVAL:
        return state.setIn(['trends', 'interval'], payload);
      case types.CHANGE_SELECTED_BAR:
        return state.setIn(['trends', 'selectedBar'], payload);
      case types.CLEANUP:
        return initialState;
      default:
        return state;
    }
  };

  return { initialState, reducer };
};
